
export const environment = {
    production: false,
  //  apiRoot: "http://localhost:83/",
    apiRoot: "http://localhost:56653/",
    //stsAuthority: "http://localhost:85",
    //stsAuthority: "http://localhost/SalesBuzzSTS/",
    stsAuthority: "http://localhost:5000/",
    clientRoot: "http://localhost:28576/",
    clientId: 'spa-client',
    version: require('../../package.json').version,
    showMenuHierarchy: true,
    timeStamp: '25/11/2024'
};
